import { Brand, Program } from '..';

const HotelsPrograms: Record<string, Program> = {
  'au-hcom': {
    id: 'au-hcom',
    name: 'Hotels.com Australia',
    brand: Brand.HOTELS,
    posa: 'AU',
    currency: 'AUD',
    locale: {
      baseName: 'en_AU',
      langId: 3081,
    },
  },

  'br-hcom': {
    id: 'br-hcom',
    name: 'Hotels.com Brazil',
    brand: Brand.HOTELS,
    posa: 'BR',
    currency: 'BRL',
    locale: {
      baseName: 'pt_BR',
      langId: 1046,
    },
  },

  'ca-hcom': {
    id: 'ca-hcom',
    name: 'Hotels.com Canada',
    brand: Brand.HOTELS,
    posa: 'CA',
    currency: 'CAD',
    locale: {
      baseName: 'en_CA',
      langId: 4105,
    },
  },

  // 'de-hcom': {
  //   id: 'de-hcom',
  //   name: 'Hotels.com Deutschland',
  //   brand: Brand.HOTELS,
  //   posa: 'DE',
  //   currency: 'EUR',
  //   locale: {
  //     baseName: 'de_DE',
  //     langId: 1031,
  //   },
  // },

  'dk-hcom': {
    id: 'dk-hcom',
    name: 'Hotels.com Danmark',
    brand: Brand.HOTELS,
    posa: 'DK',
    currency: 'EUR',
    locale: {
      baseName: 'da_DK',
      langId: 1030,
    },
  },

  'fi-hcom': {
    id: 'fi-hcom',
    name: 'Hotels.com Suomi',
    brand: Brand.HOTELS,
    posa: 'FI',
    currency: 'EUR',
    locale: {
      baseName: 'fi_FI',
      langId: 1035,
    },
  },

  'fr-hcom': {
    id: 'fr-hcom',
    name: 'Hotels.com France',
    brand: Brand.HOTELS,
    posa: 'FR',
    currency: 'EUR',
    locale: {
      baseName: 'fr_FR',
      langId: 1036,
    },
  },

  // 'is-hcom': {
  //   id: 'is-hcom',
  //   name: 'Hotels.com Iceland',
  //   brand: Brand.HOTELS,
  //   posa: 'IS',
  //   currency: 'EUR',
  //   locale: {
  //     baseName: 'is_IS',
  //     langId: 1039,
  //   },
  // },

  'jp-hcom': {
    id: 'jp-hcom',
    name: 'Hotels.com Japan',
    brand: Brand.HOTELS,
    posa: 'JP',
    currency: 'JPY',
    locale: {
      baseName: 'ja_JP',
      langId: 1041,
    },
  },

  'kr-hcom': {
    id: 'kr-hcom',
    name: 'Hotels.com South Korea',
    brand: Brand.HOTELS,
    posa: 'KR',
    currency: 'KRW',
    locale: {
      baseName: 'ko_KR',
      langId: 1042,
    },
  },

  'mx-hcom': {
    id: 'mx-hcom',
    name: 'Hotels.com Mexico',
    brand: Brand.HOTELS,
    posa: 'MX',
    currency: 'MXN',
    locale: {
      baseName: 'es_MX',
      langId: 2058,
    },
  },

  'no-hcom': {
    id: 'no-hcom',
    name: 'Hotels.com Norge',
    brand: Brand.HOTELS,
    posa: 'NO',
    currency: 'NOK',
    locale: {
      baseName: 'nb_NO',
      langId: 1044,
    },
  },

  'se-hcom': {
    id: 'se-hcom',
    name: 'Hotels.com Sverige',
    brand: Brand.HOTELS,
    posa: 'SE',
    currency: 'SEK',
    locale: {
      baseName: 'sv_SE',
      langId: 1053,
    },
  },

  'tw-hcom': {
    id: 'tw-hcom',
    name: 'Hotels.com Taiwan',
    brand: Brand.HOTELS,
    posa: 'TW',
    currency: 'TWD',
    locale: {
      baseName: 'zh_TW',
      langId: 1028,
    },
  },

  'uk-hcom': {
    id: 'uk-hcom',
    name: 'Hotels.com UK',
    brand: Brand.HOTELS,
    posa: 'GB',
    currency: 'GBP',
    locale: {
      baseName: 'en_GB',
      langId: 2057,
    },
  },

  'us-hcom': {
    id: 'us-hcom',
    name: 'Hotels.com USA',
    brand: Brand.HOTELS,
    posa: 'US',
    currency: 'USD',
    locale: {
      baseName: 'en_US',
      langId: 1033,
    },
  },
};

export { HotelsPrograms };
